var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { ChartParams } from "app/views/chart/chart.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { PaidDetailsComponent } from "../../views/modal/paid_details/paid_details.component";
import { ModalService } from "../../views/modal/base_modal.component";
import dictionary from "dict/static.json";
import { BillingService2 } from "../billing.service";
var PromocodeComponent = /** @class */ (function (_super) {
    __extends(PromocodeComponent, _super);
    function PromocodeComponent(eventsService, activatedRoute, translate, router, filter, modalService, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.filter = filter;
        _this.modalService = modalService;
        _this.service2 = service2;
        _this.addFilterParams = {
            userType: 'user',
            chartDateType: 'promocode',
            promocodeMark: '',
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
            isPromocode: true
        };
        _this.promocodeChartData = new ChartParams();
        _this.flashPromoChartData = new ChartParams();
        _this.promocodeApplyLimit = 200;
        _this.flashPromoLimit = 24;
        _this.stats = [];
        _this.statsLoader = false;
        _this.siteList = {};
        _this.tariffList = {};
        _this.sitesLoader = {};
        _this.tariffsLoader = {};
        _this.filter.addFilters.push('promocode');
        _this.currencyList = dictionary.currencyList;
        return _this;
    }
    PromocodeComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.siteList = [];
                        this.tariffList = [];
                        this.sitesLoader = {};
                        return [4 /*yield*/, this.getPromocodeChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getFlashPromoChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.getPromocodeChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, barData, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.promocodeChartData.showLoader();
                        return [4 /*yield*/, this.service2.promocode.barChart(this.filter.getCopyFilterParams({ promocodeApplyLimit: this.promocodeApplyLimit })).toPromise()];
                    case 1:
                        data = (_a.sent()).charts;
                        barData = [
                            this.translate.__A('billing._promocode.use code')
                        ];
                        for (i = 0; i <= this.promocodeApplyLimit; i++) {
                            barData.push(data[i] || '0');
                        }
                        this.promocodeChartData.setOptions({
                            type: 'bar',
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    tick: {
                                        culling: {
                                            max: 10
                                        }
                                    }
                                }
                            }
                        });
                        this.promocodeChartData.data = [barData];
                        this.promocodeChartData.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.onPromocodeApplyLimitChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPromocodeChart()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.getFlashPromoChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, barData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.flashPromoChartData.showLoader();
                        return [4 /*yield*/, this.service2.promocode.barChart(this.filter.getCopyFilterParams({ promocodeApplyLimit: this.flashPromoLimit }), 'flash_charts').toPromise()];
                    case 1:
                        data = (_a.sent()).charts;
                        barData = Object.keys(data).map(function (t) { return data[t]; });
                        barData.unshift(this.translate.__A('billing._promocode.flashpromo (by hours)'));
                        this.flashPromoChartData.setOptions({
                            type: 'bar',
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    tick: {
                                        culling: {
                                            max: 10
                                        }
                                    }
                                }
                            }
                        });
                        this.flashPromoChartData.data = [barData];
                        this.flashPromoChartData.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.onFlashPromoApplyLimitChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFlashPromoChart()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.statsLoader = true;
                        return [4 /*yield*/, this.service2.promocode.stats(this.filter.filterParams).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.stats = stats;
                        this.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.onOpenSites = function ($event, mark) {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.siteList[mark])
                            return [2 /*return*/, true];
                        if (typeof this.sitesLoader[mark] == 'undefined') {
                            this.sitesLoader[mark] = true;
                        }
                        else {
                            this.sitesLoader[mark] = !this.sitesLoader[mark];
                        }
                        if (!this.sitesLoader[mark]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.service2.promocode.stats(__assign({}, this.filter.filterParams, { mark: mark }), 'sites').toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.siteList[mark] = stats;
                        this.sitesLoader[mark] = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.onOpenTariffs = function ($event, mark) {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.tariffList[mark])
                            return [2 /*return*/, true];
                        if (typeof this.tariffsLoader[mark] == 'undefined') {
                            this.tariffsLoader[mark] = true;
                        }
                        else {
                            this.tariffsLoader[mark] = !this.tariffsLoader[mark];
                        }
                        if (!this.tariffsLoader[mark]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.service2.promocode.stats(__assign({}, this.filter.filterParams, { mark: mark }), 'tariffs').toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.tariffList[mark] = stats;
                        this.tariffsLoader[mark] = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PromocodeComponent.prototype.showPaidDetails = function (siteData) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(PaidDetailsComponent, {
                            title: siteData.domainUrl,
                            params: this.filter.filterParams,
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.siteBilling.detail(__assign({}, this.filter.filterParams, { siteIds: [siteData._id] })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    return PromocodeComponent;
}(BaseComponent));
export { PromocodeComponent };
